import React from "react";

// react router dom
import { Link } from "react-router-dom";

// components
import Button from "../../components/Button/Button";

// styled components
import styled from "styled-components";
import Typography from "../../components/Typography/Typography";

const NotFound = () => {
  return (
    <NotFoundStyle>
      <Typography size="20px">NotFound Page Components</Typography>
      <Link to="/">
        <Button bgColor="#009EF7" color="#fff">
          Back To Dashboard Admin
        </Button>
      </Link>
    </NotFoundStyle>
  );
};

const NotFoundStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 2rem;
`;

export default NotFound;
